let district = [
    { "x": -1, "y": -1, "type": "right", "opts": "start", "pickup": false },
    { "x": -2, "y": -1, "type": "right" },
    { "x": -3, "y": -1, "type": "right" },
    { "x": -5, "y": -2, "type": "righttoleft" },
    { "x": -5, "y": -3, "type": "voidleft" },
    { "x": -5, "y": -5, "type": "rightbottoleftbot" },
    { "x": -3, "y": -5, "type": "rightdown" },
    { "x": -2, "y": -6, "type": "righttoptolefttop" },
    { "x": -1, "y": -7, "type": "lefttop" },
    { "x": -2, "y": -8, "type": "top" },
    { "x": -3, "y": -9, "type": "voidbottop" },
    { "x": -4, "y": -10, "type": "topright" },
    { "x": -5, "y": -10, "type": "right" },
    { "x": -6, "y": -10, "type": "right" },
    { "x": -7, "y": -10, "type": "voidright" },
    { "x": -8, "y": -10, "type": "right" },

    { "x": -10, "y": -11, "type": "righttoleft" },
    { "x": -10, "y": -12, "type": "left" },
    { "x": -10, "y": -13, "type": "voidleft" },
    { "x": -10, "y": -14, "type": "voidleft" },
    { "x": -10, "y": -15, "type": "left" },

    { "x": -10, "y": -16, "type": "lefttop" },
    { "x": -11, "y": -17, "type": "voidbottop" },
    { "x": -12, "y": -18, "type": "topright" },
    { "x": -13, "y": -18, "type": "right" },


    { "x": -22, "y": -22, "type": "plateforme321", "pickup": false },

    /* Fake path */
    { "x": -18, "y": -13, "type": "left", "pickup": false }, 
    { "x": -18, "y": -25, "type": "leftbottorightbot", "pickup": false },

    { "x": -18, "y": -23, "type": "right", "pickup": false },

    { "x": -18, "y": -8, "type": "right", "pickup": false },
    { "x": -18, "y": -9, "type": "right", "pickup": false },
    { "x": -18, "y": -10, "type": "right", "pickup": false },
    { "x": -18, "y": -11, "type": "right", "pickup": false },
    { "x": -18, "y": -12, "type": "right", "pickup": false },

    { "x": -16, "y": -25, "type": "left", "pickup": false },
    { "x": -15, "y": -25, "type": "left", "pickup": false },
    /* */

    {
        "x": -31,
        "y": -31,
        "type": "haikouarcanedstreets",
        "move": false,
        "pickup": false
    },
    { "x": -23, "y": -18, "type": "voidright" },

    { "x": -25, "y": -19, "type": "righttoleft" },
    { "x": -25, "y": -20, "type": "voidleft" },
    { "x": -25, "y": -21, "type": "left" },
    { "x": -25, "y": -23, "type": "rightbottoleftbot", "pickup": false },
    { "x": -23, "y": -24, "type": "righttoptolefttop", "pickup": false },

    { "x": -22, "y": -25, "type": "left", "pickup": false },
    { "x": -22, "y": -26, "type": "lefttop" },
    { "x": -23, "y": -27, "type": "topleft" },
    { "x": -23, "y": -28, "type": "voidleft" },

    { "x": -24, "y": -30, "type": "lefttoright" },
    { "x": -25, "y": -30, "type": "right" },

    { "x": -27, "y": -30, "type": "leftbottorightbot" },
    //{ "x": -27, "y": -29, "type": "rightdown" },
    { "x": -27, "y": -28, "type": "voidleftdown" },
    { "x": -28, "y": -27, "type": "lefttoptorighttop" },
    { "x": -30, "y": -27, "type": "righttoleft" },
    { "x": -30, "y": -28, "type": "voidleft" },
    { "x": -30, "y": -29, "type": "left" },
    { "x": -30, "y": -30, "type": "left", "pickup": false },


    
    { "x": -31, "y": -32, "type": "lefttoright", "opts": "end", "pickup": false }
];

export default district;